import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import ProfileHook from '../../hooks/ProfileHook'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LogoutHook from '../../hooks/LogoutHook';
export default function Navbar() {
  const { getAgencyProfile } = ProfileHook()
  useEffect(() => {
    getAgencyProfile()
  }, [])

    const { agencyLogout } = LogoutHook()
    const handleLogout = () => {
        agencyLogout()
    }

  const collapsed = useSelector((state) => state.collapsed.collapsed);
  const profile = useSelector((state) => state.profile.profile);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div elevation={1} className={`${collapsed ? "collapsed fixed-top " : "main fixed-top "}`}>
      <div className='my_Navbar py-2 m-2'>
        <div className="justify-content-between d-flex px-4 py-3">
          <div className="d-flex left my-auto">
            <h6 className='my-auto'>Dashboard</h6>
            {/* <div className="search">
                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                    <input type="search" placeholder='Search' className='ms-3' name="" id="" />
                   </div> */}
          </div>
          <div className="d-flex right my-auto">
            {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 my-auto">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6  my-auto">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
            </svg> */}
            <button
              id="basic-button"
              className='d-flex'
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Avatar className="mx-1 my-auto" alt={profile.name} src={profile?.profile_pic} sx={{ width: 29, height: 29 }} />
              <span className='my-auto '>{profile.name?.length > 10 ? profile.name.slice(0, 10)+'...' : profile.name}</span>
            </button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
             
            
              <MenuItem onClick={handleLogout}>Logout</MenuItem>

            </Menu>

          </div>
        </div>
      </div>
    </div>
  )
}
